import React from "react";
import TagMeetingHeader from "../components/TagMeetingHeader";
import RegularizeAttendanceListComponent from "../components/RegularizeAttendanceListComponent";

const RegularizeAttendanceData = () => {
  return (
    <>
      <TagMeetingHeader headerName="Regularize attendance" />
      <RegularizeAttendanceListComponent />
    </>
  );
};

export default RegularizeAttendanceData;
